<template>
    <div>
        <DefaultMenu>
            <template #title>
                Configuración del Sistema
            </template>

        </DefaultMenu>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'

export default {
    name: 'CreationsMenu',

    components: {
        DefaultMenu,
    },

}
</script>
